// extracted by mini-css-extract-plugin
export default {"img":"SponsorsSection_img__JPw5c","qualcommimg":"SponsorsSection_qualcommimg__sIzMw"};